import { Component, HostListener, Injector, OnInit, OnDestroy, ViewChild, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { DxFormComponent } from 'devextreme-angular';

// components
import { ItemDetailsComponent } from '../../../shared/components/item-details/item-details.component';
import { SaveConfirmationComponent } from '../../../shared/components/save-confirmation/save-confirmation.component';

// models
import { AuctionClusterNotification } from '../../../shared/models/auction-cluster-notification';
import { Language } from '../../../shared/models/language';

// services
import { LanguageService } from '../../../shared/services/language.service';
import { NotificationManagerService } from '../../../shared/services/notification-manager.service';

const ESC_KEYCODE = 27;

@Component({
  selector: 'auction-cluster-notification-component',
  templateUrl: './auction-cluster-notification.component.html',
  styleUrls: ['./auction-cluster-notification.component.scss']
})
export class AuctionClusterNotificationComponent extends ItemDetailsComponent<AuctionClusterNotification> implements OnInit, OnDestroy {

  rtlEnabled = localStorage.getItem('last-selected-language-direction') ? JSON.parse(localStorage.getItem('last-selected-language-direction')) : false;
  private _subscription: Subscription;
  languages: Array<Language> = [];
  formDirty: boolean = false;

  @ViewChild('notificationName') notificationName;
  @ViewChild('notificationDescription') notificationDescription;
  @ViewChild('editAuctionClusterNotificationForm', { read: DxFormComponent}) auctionClusterNotificationForm: DxFormComponent;
  @ViewChild('saveConfirmation') saveConfirmation: SaveConfirmationComponent;

  @Output() onUpdated = new EventEmitter();
  @Output() onCancelled = new EventEmitter();
 
  constructor(
    protected injector: Injector,
    private languageService: LanguageService,
    private notificationManagerService: NotificationManagerService
  ) {
    super(injector);
    this._subscription = this.languageService.direction.subscribe(dir => {
      this.rtlEnabled = dir;
    });
  }
  
  ngOnInit() {
    this.model = new AuctionClusterNotification();
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
  }
  
  public onCancel() {
    this.isOpened = false;
    this.notificationName.resetLanguageButtons();
    this.notificationDescription.resetLanguageButtons();
    this.errorMessage = null;
    if(this.formDirty) {
      this.onCancelled.emit();
    }
  }
  
  open(notification: AuctionClusterNotification, languages: Array<Language>) {
    this.isOpened = true;
    this.formDirty = false;
    this.languages = languages;
    this.model = notification;
    this.createEmptyObjectForTranslatableFields();
    this.spinner.hide();
  }
  
  save() {
    this.spinner.show();
    this.notificationManagerService.updateAuctionClusterNotification(this.model)
      .subscribe((res: any) => {
        this.model = new AuctionClusterNotification();
        this.close(true);
        this.errorMessage = null;
        this.spinner.hide();
        this.onUpdated.emit();
      },
        error => {
          this.errorService.show(error);
          this.spinner.hide();
        });
    this.spinner.hide();
  }
  
  createEmptyObjectForTranslatableFields() {
    // Create empty JSON object for translation fields
    const emptyTranslation = {};
    this.languages.forEach(lang => {
      emptyTranslation[lang.code] = '';
    });
    if(!this.model.name) {
      this.model.name = JSON.stringify(emptyTranslation);
    }
    if(!this.model.description) {
      this.model.description = JSON.stringify(emptyTranslation);
    }
  }
  
  @HostListener('window:keydown', ['$event'])
  protected handleWindowKeyDownEvent(event: any) {
    if (event.keyCode === ESC_KEYCODE) {
      event.target.blur();
      if (this.formDirty) {
        this.saveConfirmation.opened = true;
      } else {
        this.onCancel();
      }
    }
  }
  
  onFieldDataChanged(e) {
    if (e.component._isReady && e.component.NAME !== 'dxPopup'){
      if (!this.formDirty) this.formDirty = true;
    }
  }
  
  onChangeTranslationField = (e: any, fieldName: string) => {
    this.formDirty = true;
    if (fieldName === 'name') {
      this.auctionClusterNotificationForm.instance.updateData(fieldName, this.notificationName.data);
    } else if (fieldName === 'description') {
      this.auctionClusterNotificationForm.instance.updateData(fieldName, this.notificationDescription.data);
    }
  }
}
